import { ShieldCheck, ArrowRight } from "lucide-react";
import { FadeUp } from "./Reveal";
import { useI18n } from "@/context/Language";

export const Transparency = () => {
  const { t } = useI18n();
  const T = t.transparency;

  return (
    <section id="transparency" className="relative py-24 sm:py-32 bg-sand-2 border-y border-border-soft">
      <div className="max-w-4xl mx-auto px-6 sm:px-8" data-testid="transparency-section">
        <FadeUp>
          <div className="flex items-center gap-2 text-terracotta">
            <ShieldCheck className="h-4 w-4" />
            <span className="text-xs font-semibold uppercase tracking-[0.2em]">{T.overline}</span>
          </div>
          <h2 className="mt-4 font-serif text-4xl sm:text-5xl tracking-tight text-ink text-balance">
            {T.heading}
          </h2>
        </FadeUp>

        <FadeUp delay={0.12}>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-[auto_1fr_auto_1fr_auto_1fr] items-center gap-4 sm:gap-3 text-sm">
            <div className="rounded-full border border-border-soft bg-sand px-4 py-2 font-semibold text-ink" data-testid="flow-donor">Donor</div>
            <div className="hidden sm:flex items-center justify-center text-ink/40"><ArrowRight className="h-4 w-4" /></div>
            <div className="rounded-full border border-border-soft bg-sand px-4 py-2 text-ink/80" data-testid="flow-gofundme">GoFundMe</div>
            <div className="hidden sm:flex items-center justify-center text-ink/40"><ArrowRight className="h-4 w-4" /></div>
            <div className="rounded-full border border-border-soft bg-sand px-4 py-2 text-ink/80" data-testid="flow-reina">Reina Yohana Isaza Montoya · Spain</div>
            <div className="hidden sm:flex items-center justify-center text-ink/40"><ArrowRight className="h-4 w-4" /></div>
            <div className="sm:col-span-5 rounded-full border border-terracotta/30 bg-terracotta/10 px-4 py-2 font-semibold text-ink" data-testid="flow-church">Pastor Ángel Aner González · Iglesia Cristiana Ríos de Agua Viva</div>
          </div>

          <p className="mt-8 max-w-2xl text-base leading-relaxed text-ink/70" data-testid="transparency-body">
            {T.body}
          </p>

          <p className="mt-6 max-w-2xl text-xs leading-relaxed text-ink/50" data-testid="transparency-builder-note">
            {T.builderNote}
          </p>
        </FadeUp>
      </div>
    </section>
  );
};

export default Transparency;
